<template>
  <NoticeAlert
    v-if="show"
    color="blue25 text-neutral900"
    icon-color="text-blue400"
    @update:model-value="dismiss"
  >
    {{ text }}

    <router-link class="text-blue600 font-weight-semibold" :to="target.path">
      {{ t('alert.public_collection_return.cta') }}
    </router-link>
  </NoticeAlert>
</template>

<script setup>
import { computed } from 'vue'
import { useStore } from 'vuex'
import { useI18n } from 'vue-i18n'
import NoticeAlert from '@/components/global/NoticeAlert.vue'

// Offers a way back to the public collection the user was reading before a
// sign-up wall sent them into the auth flow (see utils/public-collection-return).
// Following the link navigates into the collection, which is what clears the
// stored target — the router guard owns that, not this component.
const store = useStore()
const { t } = useI18n()

const target = computed(() => store.getters['auth/publicCollectionReturn'])
const show = computed(() => !!target.value && !!store.getters['auth/userId'])

const text = computed(() => {
  if (!target.value) return ''

  const { collectionName, ownerUsername } = target.value

  if (!collectionName) {
    return t('alert.public_collection_return.text_no_name', { creator: ownerUsername })
  }

  return t('alert.public_collection_return.text', {
    collection: collectionName,
    creator: ownerUsername,
  })
})

function dismiss() {
  store.commit('auth/setPublicCollectionReturn', null)
}
</script>
